
import React from 'react';

import "../../../App.css";
import "./NavBarWeb.css";

export default function NavBarWeb(props) {

    const routes = props.routes;
    const selected = props.selected;
    const setSelected = props.setSelected;

    const handleClick = (route) => {

        let idx = -1;

        for (let i = 0; i < routes.length; i++) {

            if (routes[i].title === route.title) {
                idx = i;
                break;
            }
        }

        if (idx > -1) {
            setSelected(idx);
        }
    }

    return (
        <React.Fragment>
            <div
                className={
                    "default-max-width default-align-center default-margin-top-medium " +
                    "default-text-align-center default-justify-center default-margin-auto"
                }
                style={{
                    maxWidth: "860px",
                }}
            >
                <div
                    className={"default-display-flex default-align-center default-justify-center "}
                >
                    {
                        routes.map((route, index) => {
                            const style = {
                                marginLeft: "20px",
                                marginRight: "20px"
                            }

                            if (index === selected) {
                                style["fontWeight"] = "bold";
                            }

                            return <div
                                        key={"route_"+index}
                                        style={style}
                                        className={"navbar-item"}
                                        onClick={()=>handleClick(route)}
                                    >
                                        <div
                                            style={{
                                                marginBottom: "10px",
                                            }}
                                        >
                                            {route.title}
                                        </div>
                                        <div
                                            style={index === selected ? {
                                                borderBottom: "3px solid #fff",
                                            } : {}}
                                        >
                                        </div>
                                    </div>
                        })
                    }
                </div>

            </div>
        </React.Fragment>
    )

}